export default __webpack_public_path__ + "static/media/t_19_2076.c25b9a82.png";